import { FC, useMemo } from 'react';

import classNames from 'classnames';

import './ContentList.scss';

import { TestMetadata } from '../types';

export interface ContentListProps {
  /** Class name for Content List */
  className?: string;
  // Test IDs for component sections
  testMetadata?: TestMetadata;
}

const ContentList: FC<ContentListProps> = ({
  children,
  className,
  testMetadata,
  ...otherProps
}) => {
  const contentListClassNames = useMemo(
    () => classNames('sb-content-list', className),
    [className],
  );

  return (
    <ul {...otherProps} className={contentListClassNames} {...testMetadata}>
      {children}
    </ul>
  );
};

export default ContentList;
